<template>
  <div class="personal-wallpaper-item">
    <div class="pic">
      <img :src="data.preview_jpg" alt>
    </div>
    <div class="name">
      <span>{{ data.wname }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PersonalWallpaperItem',
  props: {
    data: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {}
  },
  methods: {},
}
</script>

<style scoped lang="scss">
.personal-wallpaper-item {
  position: relative;
  width: 406px;
  height: 228px;
  border-radius: 6px;
  overflow: hidden;
  .pic {
    width: 100%;
    height: 100%;
    background: #f1f1f1;
    img {
      width: 100%;
    }
  }
  .name {
    z-index: 1;
    position: absolute;
    left: 0;
    right: 0;
    top: 0px;
    height: 32px;
    padding-left: 10px;
    line-height: 32px;
    font-size: 14px;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0));
    color: #fff;
  }
}
</style>
